import ColorTokenTable from 'components/ColorTokenTable';
import React from 'react';
export default {
  ColorTokenTable,
  React
};